<template>
    <li class="category-card-item">
        <div class="word">
            <span class="title">{{ item.name }}</span>
            <span class="count">{{ item.bookCount }}本</span>
        </div>
        <div class="imgpic">
            <img :src="getImgCover(item.bookCover[0])" alt="" />
            <img :src="getImgCover(item.bookCover[1])" alt="" />
            <img :src="getImgCover(item.bookCover[2])" alt="" />
        </div>
    </li>
</template>

<script>
export default {
    props: ["item"],
    methods: {
        getImgCover(url) {
            return "https://statics.zhuishushenqi.com" + url;
        }
    }
};
</script>

<style lang="less">
li.category-card-item {
    position: relative;
    display: flex;
    width: 45%;
    float: left;
    padding: 20px 5px;
    margin: 10px 3px;
    background: rgb(241, 241, 241);
    .word {
        flex: 1;
        display: flex;
        flex-direction: column;
        padding-left: 5px;
        span {
            // flex: 1;
            &.title {
                font-size: 15px;
                color: #666;
            }
            &.count {
                font-size: 12px;
                color: #999;
            }
        }
    }
    .imgpic {
        position: absolute;
        bottom: 0;
        right: 0;
        img {
            width: 45px;
            &:nth-child(1),&:nth-child(2){
                transform: scale(0.8) translate(0,3px);
            }
            &:last-child{
                position: absolute;
                top: 0;
                right: 0;
                transform: translate(-50%,0);
                z-index: 1;
            }
            
        }
    }
}
</style>
